const config = document.getElementById('rudo-optional-components');
const modules = new Map(Object.entries(JSON.parse(config?.textContent || '{}')));
const loading = new Set();
function scan(root) {
  if (!(root instanceof Element || root instanceof Document)) return;
  for (const [tag, url] of modules) {
    if (loading.has(tag) || !(root.matches?.(tag) || root.querySelector(tag))) continue;
    loading.add(tag);
    import(url).then(() => modules.delete(tag)).catch(() => loading.delete(tag));
  }
}
scan(document);
// Only inspect inserted subtrees (e.g. quick-add); never rescan the body on each mutation.
const observer = new MutationObserver(records => {
  if (!modules.size) return observer.disconnect();
  for (const record of records) for (const node of record.addedNodes) scan(node);
});
observer.observe(document.body, { childList: true, subtree: true });
